import React from 'react'

export const Download = (): JSX.Element => (
    <svg
        width="150"
        height="128"
        viewBox="0 0 150 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_1110_843)">
            <path
                opacity="0.7"
                d="M110.837 2.8623H39.1628L3.32568 63.815L39.1628 124.782H110.837L146.674 63.815L110.837 2.8623Z"
                fill="#101010"
            />
            <g opacity="0.75">
                <path
                    opacity="0.75"
                    d="M110.837 2.8623L146.674 63.815L110.837 124.768H39.1629L3.3257 63.815L39.1629 2.8623H110.837V2.8623ZM112.486 0H37.5287L36.6973 1.43115L0.8601 62.3838L0 63.815L0.8601 65.2461L36.6973 126.213L37.5287 127.644H112.486L113.317 126.213L149.154 65.2461L150 63.815L149.154 62.3838L113.317 1.43115L112.486 0V0Z"
                    fill="#777777"
                />
            </g>
        </g>
        <path
            d="M87.8125 56.357L78.3661 65.7018V26.6826H70.9149V65.7018L61.4652 56.357L56.1948 61.5686L72.0059 77.2053C73.4612 78.646 75.8221 78.646 77.2741 77.2053L93.0851 61.5686L87.8125 56.357Z"
            fill="#FFCD05"
        />
        <path
            d="M100.721 78.9135V93.6578H48.558V78.9135H41.1057V93.6578C41.1057 97.7094 44.4602 101.029 48.558 101.029H100.721C104.819 101.029 108.173 97.7094 108.173 93.6578V78.9135H100.721Z"
            fill="#FFCD05"
        />
        <defs>
            <clipPath id="clip0_1110_843">
                <rect width="150" height="127.644" fill="white" />
            </clipPath>
        </defs>
    </svg>
)
